import { selfAxios } from "../../../../../axios/selfAxios.js";
async function getGetOrgMarketExtendCompositeDataListByFictitiousShopId(params) {
  const { data } = await selfAxios.get(`/ucenterapi/internal/business/getOrgMarketExtendCompositeDataListByFictitiousShopId`, { params });
  return data == null ? void 0 : data.data;
}
export { getGetOrgMarketExtendCompositeDataListByFictitiousShopId };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/ucenterapi/internal/business/getOrgMarketExtendCompositeDataListByFictitiousShopId/get.js